export const getAllObjects = () => {
  const objArray: Array<Verge.Object> = [];
  const appInstance = window.v3d.apps[0];
  appInstance.scene.traverse((obj: Verge.Object) => objArray.push(obj));
  return objArray;
};
